module.exports = __webpack_public_path__ + "media/coins.25634c51.mp3";